import styled from "styled-components";
import { css } from "styled-components";
import { AccordionContent, AccordionHeader } from "../../../accordion/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import * as SS from "../../styled.js";
import tabsMobileThemes from "./themes/index.js";
export const tabsColorStyles = (color = 'default')=>({
        default: css``,
        primary: css`
			box-shadow: none;
			border-radius: 0;

			${SS.TabsWrapper} {
				border-top: 0;
			}

			${SS.TabsCarouselList} {
				border-bottom: 2px solid var(--primary-list-border-bottom-color);
			}

			${SS.TabsCarouselItem} {
				${FlexMixin({})}
				flex-basis: 100%;
				margin-right: 0;
				max-width: 50%;
				min-width: 50%;
				width: 50%;

				${SS.TabsButton} {
					color: var(--primary-button-color);
					overflow: hidden;
					text-overflow: ellipsis;
					text-transform: none;
					white-space: nowrap;

					&.is-active {
						${FontMixin({
            weight: 'regular'
        })}
						background-color: var(--primary-active-background);
						border-bottom-color: var(--primary-active-border-bottom-color);
						color: var(--primary-active-color);
					}
				}
			}
		`
    })[color];
export const TabsStyled = styled(SS.TabsStyled).withConfig({
    displayName: "styled__TabsStyled",
    componentId: "sc-c0bab953-0"
})`
	--primary-list-border-bottom-color: ${({ theme  })=>theme.colors.primary.lighter};
	--primary-button-color: ${({ theme  })=>theme.colors.grays.darker};
	--primary-active-background: ${({ theme  })=>theme.colors.primary.lighter};
	--primary-active-border-bottom-color: ${({ theme  })=>theme.colors.primary.lighter};
	--primary-active-color: ${({ theme  })=>theme.colors.white.base};

	${({ color  })=>tabsColorStyles(color)}

	${({ theme  })=>tabsMobileThemes[theme.id]?.TabsStyled?.()}
`;
export const AccordionWrapper = styled.div.withConfig({
    displayName: "styled__AccordionWrapper",
    componentId: "sc-c0bab953-1"
})`
	${AccordionHeader} {
		padding: 12px 16px;
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})};
		background-color: ${({ theme  })=>theme.colors.white.base};
		color: ${({ theme  })=>theme.colors.grays.darker};
	}

	${AccordionContent} {
		${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'base'
})}
		border-top: 1px solid ${({ theme  })=>theme.colors.grays.light};
		background-color: ${({ theme  })=>theme.bodyBgColor};
	}
`;

//# sourceMappingURL=styled.js.map